import { guideSeenKey } from '@cerebro-diem/core';

// Whether this browser has shown the user "How Cerebro works". Kept in
// localStorage, per user: the guide opens by itself once per user per browser.
// Storage that cannot be read (a private window, blocked site data) counts as
// seen, so the guide never opens on every page load.

export function hasSeenGuide(userId: string): boolean {
  try {
    return window.localStorage.getItem(guideSeenKey(userId)) !== null;
  } catch {
    return true;
  }
}

export function markGuideSeen(userId: string): void {
  try {
    window.localStorage.setItem(guideSeenKey(userId), new Date().toISOString());
  } catch {
    // Nothing to remember it in; hasSeenGuide treats that as seen.
  }
}
